import { render } from "./KpiCompositeGrid.vue?vue&type=template&id=273bb059"
import script from "./KpiCompositeGrid.vue?vue&type=script&lang=js"
export * from "./KpiCompositeGrid.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__